import './ClosedIcons.less';

const BetLostIcon = ({ height = 26, width = 26, closedBet = false }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
            className="closing-icon"
        >
            <path
                d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm0 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zM5.446 4.397l.084.073L8 6.939l2.47-2.47a.75.75 0 0 1 1.133.977l-.073.084L9.061 8l2.47 2.47a.75.75 0 0 1-.977 1.133l-.084-.073L8 9.061l-2.47 2.47a.75.75 0 0 1-1.133-.977l.073-.084L6.939 8l-2.47-2.47a.75.75 0 0 1 .977-1.133z"
                fill={closedBet ? '#1261A0' : '#ff442b'}
                fillRule="evenodd"
            />
        </svg>
    );
};

export default BetLostIcon;
